class ProductSwiperSlide extends HTMLElement {
    constructor() {
        super();

        this.casouselSlide = this.querySelector('.product-casousel__slideshow');
        this.perView = this.casouselSlide.getAttribute('per-view');
        new Swiper(this.casouselSlide, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            speed: 500,
            autoHeight: false,
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                749: {
                    slidesPerView: this.perView,
                    spaceBetween: 0,
                }
            },
        });
    }
}
customElements.define("swiper-container", ProductSwiperSlide);
